import { render, staticRenderFns } from "./change-cus-info.vue?vue&type=template&id=5087a43e&scoped=true"
import script from "./change-cus-info.vue?vue&type=script&lang=js"
export * from "./change-cus-info.vue?vue&type=script&lang=js"
import style0 from "./change-cus-info.vue?vue&type=style&index=0&id=5087a43e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087a43e",
  null
  
)

export default component.exports